/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { RegistrationResultDto as PlatformRegistrationResultDto } from '../models/platform/registration-result-dto';
import { registerTenant } from '../fn/register-tenant/register-tenant';
import { RegisterTenant$Params } from '../fn/register-tenant/register-tenant';

@Injectable({ providedIn: 'root' })
export class RegisterTenantClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `registerTenantRegisterTenant()` */
  static readonly RegisterTenantRegisterTenantPath = '/tenant/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerTenant$Response(body: RegisterTenant$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<PlatformRegistrationResultDto>> {
    const obs = registerTenant(this.http, this.rootUrl, { body } satisfies RegisterTenant$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerTenant(body: RegisterTenant$Params['body'], context?: HttpContext): Observable<PlatformRegistrationResultDto> {
    const resp = this.registerTenant$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlatformRegistrationResultDto>): PlatformRegistrationResultDto => r.body)
    );
  }

}
